import { render, staticRenderFns } from "./Windowscreen.vue?vue&type=template&id=0412c8f7&scoped=true&"
import script from "./Windowscreen.vue?vue&type=script&lang=js&"
export * from "./Windowscreen.vue?vue&type=script&lang=js&"
import style0 from "./Windowscreen.vue?vue&type=style&index=0&id=0412c8f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412c8f7",
  null
  
)

export default component.exports